import { useCallback, useEffect, useState } from 'react'

import ConversationsApiService from '@/apis/conversationsApiService'
import type { ConversationDetail } from '@/types/chat'

export default function useConversation(id: string | null) {
  const [conversation, setConversation] = useState<ConversationDetail | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const load = useCallback(
    async (signal?: AbortSignal) => {
      if (!id) {
        setConversation(null)
        return
      }
      setIsLoading(true)
      try {
        const data = await ConversationsApiService.show(id, signal)
        setConversation(data)
      } catch (err) {
        if ((err as { name?: string }).name === 'CanceledError') return
        // Other errors handled by global 401 interceptor
      } finally {
        setIsLoading(false)
      }
    },
    [id],
  )

  useEffect(() => {
    const controller = new AbortController()
    load(controller.signal)
    return () => controller.abort()
  }, [load])

  return { conversation, isLoading, refetch: load }
}
